module.exports = __webpack_public_path__ + "static/img/qiWchart.842cc45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/qiWchart.png
// module id = VKhi
// module chunks = 8